// extracted by mini-css-extract-plugin
export var lg = "_ht-7";
export var md = "_ht-6";
export var placeholderContainer = "_ht-1";
export var placeholderIcon = "_ht-2";
export var productImage = "_ht-0";
export var sm = "_ht-5";
export var xl = "_ht-8";
export var xs = "_ht-4";
export var xxs = "_ht-3";